<div class="dali102-container">
  <!-- Address -->
  <div class="row mt-3">
    <div class="col-3">
      <div class="signifyBookmd bold-text" id="DALI102-address-text">Address</div>
    </div>
  </div>

  <!-- Grid Layout for Short Address and Groups -->
  <div class="aligned-sections-grid">

<!--     Short Address Row-->
    <div class="grid-labels ">
      <div class="signifyBookmd shorttext col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 filters-heading" id="DALI102-short-address-text">
        Short address
        <img class="info" (click)="openInfo($event)" (keydown.enter)="openInfo($event)" (keydown.space)="openInfo($event); $event.preventDefault()" src="{{ pathVal }}info.png" placement="right" [autoClose]="'outside'" [ngbTooltip]="shortAddressConfig" triggers="click:blur" tooltipClass="dali-info-tooltip" #shortAddr="ngbTooltip" (click)="shortAddr.open()" alt="Information" />
        <ng-template #shortAddressConfig>
          <div class="row app-area-container">
            <div class="col-9 title-tooltip">Short Address</div>
            <div class="col-3 tooltip-image">
              <img src="{{ pathVal }}close.png" (click)="[shortAddr.close(), openInfo($event)]" (keydown.enter)="[shortAddr.close(), openInfo($event)]" (keydown.space)="[shortAddr.close(), openInfo($event)]; $event.preventDefault()" alt="Close" />
            </div>
            <div class="col-12 tooltip-description px-0">
              Short address can either be 255 or between 0 - 63
            </div>
          </div>
        </ng-template>
      </div>
      <div class="inputboxselection">
        <input
          type="number"
          (keypress)="numberOnly($event)"
          (paste)="onPaste($event)"
          [value]="shortAddressValue === 255 ? '' : shortAddressValue"
          (input)="onShortAddressInput($event.target.value)"
          class="input-text form-control signifyBookmd textbox-standard"
          [ngClass]="{'myStyle': shortAddressError === true}"
          id="DALI102-short-address-input"
        />
      </div>
    </div>

    <!-- Groups Row -->
    <div class="grid-label mt-4">
      <div class="signifyBookmd bold-text" id="DALI102-groups-text">Groups</div>
    </div>
    <div class="grid-content mt-4">
      <div class="groups-grid">
        <!-- Column 1: Groups 0-3 -->
        <div class="group-column">
          <div class="group-item">
            <span class="group-label" id="DALI102-group-0-text">Group 0</span>
            <input type="checkbox" class="p-checkbox" id="DALI102-group-0-checkbox" [(ngModel)]="groups[0]" (change)="onGroupChange()" aria-labelledby="DALI102-group-0-text" />
          </div>
          <div class="group-item">
            <span class="group-label" id="DALI102-group-1-text">Group 1</span>
            <input type="checkbox" class="p-checkbox" id="DALI102-group-1-checkbox" [(ngModel)]="groups[1]" (change)="onGroupChange()" aria-labelledby="DALI102-group-1-text" />
          </div>
          <div class="group-item">
            <span class="group-label" id="DALI102-group-2-text">Group 2</span>
            <input type="checkbox" class="p-checkbox" id="DALI102-group-2-checkbox" [(ngModel)]="groups[2]" (change)="onGroupChange()" aria-labelledby="DALI102-group-2-text" />
          </div>
          <div class="group-item">
            <span class="group-label" id="DALI102-group-3-text">Group 3</span>
            <input type="checkbox" class="p-checkbox" id="DALI102-group-3-checkbox" [(ngModel)]="groups[3]" (change)="onGroupChange()" aria-labelledby="DALI102-group-3-text" />
          </div>
        </div>
        <!-- Column 2: Groups 4-7 -->
        <div class="group-column">
          <div class="group-item">
            <span class="group-label" id="DALI102-group-4-text">Group 4</span>
            <input type="checkbox" class="p-checkbox" id="DALI102-group-4-checkbox" [(ngModel)]="groups[4]" (change)="onGroupChange()" aria-labelledby="DALI102-group-4-text" />
          </div>
          <div class="group-item">
            <span class="group-label" id="DALI102-group-5-text">Group 5</span>
            <input type="checkbox" class="p-checkbox" id="DALI102-group-5-checkbox" [(ngModel)]="groups[5]" (change)="onGroupChange()" aria-labelledby="DALI102-group-5-text" />
          </div>
          <div class="group-item">
            <span class="group-label" id="DALI102-group-6-text">Group 6</span>
            <input type="checkbox" class="p-checkbox" id="DALI102-group-6-checkbox" [(ngModel)]="groups[6]" (change)="onGroupChange()" aria-labelledby="DALI102-group-6-text" />
          </div>
          <div class="group-item">
            <span class="group-label" id="DALI102-group-7-text">Group 7</span>
            <input type="checkbox" class="p-checkbox" id="DALI102-group-7-checkbox" [(ngModel)]="groups[7]" (change)="onGroupChange()" aria-labelledby="DALI102-group-7-text" />
          </div>
        </div>
        <!-- Column 3: Groups 8-11 -->
        <div class="group-column">
          <div class="group-item">
            <span class="group-label" id="DALI102-group-8-text">Group 8</span>
            <input type="checkbox" class="p-checkbox" id="DALI102-group-8-checkbox" [(ngModel)]="groups[8]" (change)="onGroupChange()" aria-labelledby="DALI102-group-8-text" />
          </div>
          <div class="group-item">
            <span class="group-label" id="DALI102-group-9-text">Group 9</span>
            <input type="checkbox" class="p-checkbox" id="DALI102-group-9-checkbox" [(ngModel)]="groups[9]" (change)="onGroupChange()" aria-labelledby="DALI102-group-9-text" />
          </div>
          <div class="group-item">
            <span class="group-label" id="DALI102-group-10-text">Group 10</span>
            <input type="checkbox" class="p-checkbox" id="DALI102-group-10-checkbox" [(ngModel)]="groups[10]" (change)="onGroupChange()" aria-labelledby="DALI102-group-10-text" />
          </div>
          <div class="group-item">
            <span class="group-label" id="DALI102-group-11-text">Group 11</span>
            <input type="checkbox" class="p-checkbox" id="DALI102-group-11-checkbox" [(ngModel)]="groups[11]" (change)="onGroupChange()" aria-labelledby="DALI102-group-11-text" />
          </div>
        </div>
        <!-- Column 4: Groups 12-15 -->
        <div class="group-column">
          <div class="group-item">
            <span class="group-label" id="DALI102-group-12-text">Group 12</span>
            <input type="checkbox" class="p-checkbox" id="DALI102-group-12-checkbox" [(ngModel)]="groups[12]" (change)="onGroupChange()" aria-labelledby="DALI102-group-12-text" />
          </div>
          <div class="group-item">
            <span class="group-label" id="DALI102-group-13-text">Group 13</span>
            <input type="checkbox" class="p-checkbox" id="DALI102-group-13-checkbox" [(ngModel)]="groups[13]" (change)="onGroupChange()" aria-labelledby="DALI102-group-13-text" />
          </div>
          <div class="group-item">
            <span class="group-label" id="DALI102-group-14-text">Group 14</span>
            <input type="checkbox" class="p-checkbox" id="DALI102-group-14-checkbox" [(ngModel)]="groups[14]" (change)="onGroupChange()" aria-labelledby="DALI102-group-14-text" />
          </div>
          <div class="group-item">
            <span class="group-label" id="DALI102-group-15-text">Group 15</span>
            <input type="checkbox" class="p-checkbox" id="DALI102-group-15-checkbox" [(ngModel)]="groups[15]" (change)="onGroupChange()" aria-labelledby="DALI102-group-15-text" />
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
